import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { add, remove, update, getLazyMenuList, getMenu } from "@/api/system/menu";
import { addDataScope, removeDataScope, updateDataScope, getListDataScope, getMenuDataScope } from "@/api/system/scope";
import { mapGetters } from "vuex";
import iconList from "@/config/iconList";
import func from "@/util/func";
export default {
  data: function data() {
    return {
      form: {},
      selectionList: [],
      query: {},
      loading: true,
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      drawerVisible: false,
      direction: 'rtl',
      scopeMenuId: 0,
      scopeMenuCode: '',
      scopeMenuName: "菜单",
      scopeLoading: false,
      menu: true,
      watchMode: true,
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        dialogWidth: "60%",
        tree: true,
        border: true,
        index: true,
        selection: true,
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menuWidth: 150,
        dialogClickModal: false,
        column: [{
          label: "菜单名称",
          prop: "name",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单名称",
            trigger: "blur"
          }]
        }, {
          label: "路由地址",
          prop: "path",
          rules: [{
            required: true,
            message: "请输入路由地址",
            trigger: "blur"
          }]
        }, {
          label: "上级菜单",
          prop: "parentId",
          type: "tree",
          dicUrl: "/api/blade-system/menu/tree",
          hide: true,
          props: {
            label: "title"
          },
          rules: [{
            required: false,
            message: "请选择上级菜单",
            trigger: "click"
          }]
        }, {
          label: "菜单图标",
          prop: "source",
          type: "icon",
          slot: true,
          width: 80,
          iconList: iconList,
          rules: [{
            required: true,
            message: "请输入菜单图标",
            trigger: "click"
          }]
        }, {
          label: "菜单编号",
          prop: "code",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单编号",
            trigger: "blur"
          }]
        }, {
          label: "菜单类型",
          prop: "category",
          type: "radio",
          dicData: [{
            label: "菜单",
            value: 1
          }, {
            label: "按钮",
            value: 2
          }],
          hide: true,
          rules: [{
            required: true,
            message: "请选择菜单类型",
            trigger: "blur"
          }]
        }, {
          label: "菜单别名",
          prop: "alias",
          rules: [{
            required: true,
            message: "请输入菜单别名",
            trigger: "blur"
          }]
        }, {
          label: "按钮功能",
          prop: "action",
          type: "radio",
          dicData: [{
            label: "工具栏",
            value: 0
          }, {
            label: "操作栏",
            value: 1
          }, {
            label: "工具操作栏",
            value: 2
          }],
          hide: true,
          rules: [{
            required: true,
            message: "请选择按钮功能",
            trigger: "blur"
          }]
        }, {
          label: "菜单排序",
          prop: "sort",
          type: "number",
          width: 80,
          rules: [{
            required: true,
            message: "请输入菜单排序",
            trigger: "blur"
          }]
        }, {
          label: "新窗口",
          prop: "isOpen",
          type: "radio",
          dicData: [{
            label: "否",
            value: 0
          }, {
            label: "是",
            value: 1
          }],
          hide: true
        }, {
          label: "菜单备注",
          prop: "remark",
          type: "textarea",
          span: 24,
          minRows: 6,
          hide: true
        }]
      },
      data: [],
      formScope: {},
      selectionListScope: [],
      pageScope: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      optionScope: {
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        menuWidth: 200,
        dialogWidth: 900,
        dialogClickModal: false,
        column: [{
          label: "权限名称",
          prop: "scopeName",
          search: true,
          value: "",
          rules: [{
            required: true,
            message: "请输入数据权限名称",
            trigger: "blur"
          }]
        }, {
          label: "权限编号",
          prop: "resourceCode",
          search: true,
          width: 100,
          rules: [{
            required: true,
            message: "请输入数据权限编号",
            trigger: "blur"
          }]
        }, {
          label: "权限字段",
          prop: "scopeColumn",
          width: 130,
          rules: [{
            required: true,
            message: "请输入数据权限编号",
            trigger: "blur"
          }]
        }, {
          label: "规则类型",
          type: "select",
          dicUrl: "/api/blade-system/dict/dictionary?code=data_scope_type",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          slot: true,
          width: 140,
          prop: "scopeType",
          rules: [{
            required: true,
            message: "请输入通知类型",
            trigger: "blur"
          }]
        }, {
          label: "可见字段",
          prop: "scopeField",
          span: 24,
          hide: true,
          value: "*",
          rules: [{
            required: true,
            message: "请输入数据权限可见的字段",
            trigger: "blur"
          }]
        }, {
          label: "权限类名",
          prop: "scopeClass",
          span: 24,
          hide: true,
          rules: [{
            required: true,
            message: "请输入MybatisMapper对应方法的完整类名路径",
            trigger: "blur"
          }]
        }, {
          label: "规则值",
          prop: "scopeValue",
          span: 24,
          minRows: 5,
          type: "textarea",
          display: true,
          hide: true
        }, {
          label: "备注",
          prop: "remark",
          span: 24,
          hide: true
        }]
      },
      dataScope: []
    };
  },
  watch: {
    'formScope.scopeType': function formScopeScopeType() {
      this.initScope();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.menu_add, false),
        viewBtn: this.vaildData(this.permission.menu_view, false),
        delBtn: this.vaildData(this.permission.menu_delete, false),
        editBtn: this.vaildData(this.permission.menu_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    scopeIds: function scopeIds() {
      var ids = [];
      this.selectionListScope.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    initScope: function initScope() {
      var _this = this;

      var scopeType = func.toInt(this.formScope.scopeType);
      var watchMode = this.watchMode;
      var column = "-",
          name = "暂无";

      if (scopeType === 1) {
        column = "-";
        name = "全部可见";
      } else if (scopeType === 2) {
        column = "create_user";
        name = "本人可见";
      } else if (scopeType === 3) {
        column = "create_dept";
        name = "所在机构可见";
      } else if (scopeType === 4) {
        column = "create_dept";
        name = "所在机构可见及子级可见";
      } else if (scopeType === 5) {
        column = "";
        name = "自定义";
      }

      this.$refs.crudScope.option.column.filter(function (item) {
        if (watchMode) {
          if (item.prop === "scopeName") {
            _this.formScope.scopeName = "".concat(_this.scopeMenuName, " [").concat(name, "]");
          }

          if (item.prop === "resourceCode") {
            _this.formScope.resourceCode = _this.scopeMenuCode;
          }

          if (item.prop === "scopeColumn") {
            _this.formScope.scopeColumn = column;
          }
        }

        if (item.prop === "scopeValue") {
          item.display = scopeType === 5;
        }
      });
    },
    // 菜单管理模块
    rowSave: function rowSave(row, done, loading) {
      var _this2 = this;

      add(row).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this3 = this;

      update(row).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this4 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.parentId = 0;
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.parentId = '';
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this5 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this5.ids);
      }).then(function () {
        _this5.onLoad(_this5.page);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });

        _this5.$refs.crud.toggleSelection();
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this6 = this;

      if (["edit", "view"].includes(type)) {
        getMenu(this.form.id).then(function (res) {
          _this6.form = res.data.data;
        });
      }

      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this7 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getLazyMenuList(this.parentId, Object.assign(params, this.query)).then(function (res) {
        _this7.data = res.data.data;
        _this7.loading = false;

        _this7.selectionClear();
      });
    },
    treeLoad: function treeLoad(tree, treeNode, resolve) {
      var parentId = tree.id;
      getLazyMenuList(parentId).then(function (res) {
        resolve(res.data.data);
      });
    },
    // 数据权限模块
    handleDataScope: function handleDataScope(row) {
      this.drawerVisible = true;
      this.scopeMenuId = row.id;
      this.scopeMenuCode = row.code;
      this.scopeMenuName = row.name;
      this.onLoadScope(this.pageScope);
    },
    handleDrawerClose: function handleDrawerClose(hide) {
      hide();
    },
    rowSaveScope: function rowSaveScope(row, done, loading) {
      var _this8 = this;

      row = _objectSpread(_objectSpread({}, row), {}, {
        menuId: this.scopeMenuId
      });
      addDataScope(row).then(function () {
        _this8.onLoadScope(_this8.pageScope);

        _this8.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdateScope: function rowUpdateScope(row, index, done, loading) {
      var _this9 = this;

      row = _objectSpread(_objectSpread({}, row), {}, {
        menuId: this.scopeMenuId
      });
      updateDataScope(row).then(function () {
        _this9.onLoadScope(_this9.pageScope);

        _this9.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDelScope: function rowDelScope(row) {
      var _this10 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return removeDataScope(row.id);
      }).then(function () {
        _this10.onLoadScope(_this10.pageScope);

        _this10.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    handleDeleteScope: function handleDeleteScope() {
      var _this11 = this;

      if (this.selectionListScope.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return removeDataScope(_this11.scopeIds);
      }).then(function () {
        _this11.onLoadScope(_this11.pageScope);

        _this11.$message({
          type: "success",
          message: "操作成功!"
        });

        _this11.$refs.crudScope.toggleSelection();
      });
    },
    beforeOpenScope: function beforeOpenScope(done, type) {
      var _this12 = this;

      if (["add"].includes(type)) {
        this.watchMode = true;
        this.initScope();
      }

      if (["edit", "view"].includes(type)) {
        this.watchMode = false;
        getMenuDataScope(this.formScope.id).then(function (res) {
          _this12.formScope = res.data.data;
        });
      }

      done();
    },
    searchResetScope: function searchResetScope() {
      this.onLoadScope(this.pageScope);
    },
    searchChangeScope: function searchChangeScope(params, done) {
      this.onLoadScope(this.pageScope, params);
      done();
    },
    selectionChangeScope: function selectionChangeScope(list) {
      this.selectionListScope = list;
    },
    currentChangeScope: function currentChangeScope(currentPage) {
      this.pageScope.currentPage = currentPage;
    },
    sizeChangeScope: function sizeChangeScope(pageSize) {
      this.pageScope.pageSize = pageSize;
    },
    onLoadScope: function onLoadScope(page) {
      var _this13 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.scopeLoading = true;

      var values = _objectSpread(_objectSpread({}, params), {}, {
        menuId: this.scopeMenuId
      });

      getListDataScope(page.currentPage, page.pageSize, Object.assign(values, this.query)).then(function (res) {
        var data = res.data.data;
        _this13.pageScope.total = data.total;
        _this13.dataScope = data.records;
        _this13.selectionListScope = [];
        _this13.scopeLoading = false;
      });
    }
  }
};